/* Paginate eligible results, rather than asking shoppers to traverse sparse
   Shopify pages. Keep native query/facet/sort URLs and check live stock before
   displaying each product. Never download the entire catalogue in a burst. */
(function () {
  'use strict';
  if (/\/search\/?$/.test(location.pathname) && window.TntSearchResults) return;
  var active, lastRequest = 0, bootTimer, resetRequested = false;
  var PAGE_SIZE = 24;
  var names = { NL: 'Newfoundland', NS: 'Nova Scotia', NB: 'New Brunswick',
    PE: 'Prince Edward Island', ON: 'Ontario', QC: 'Quebec', MB: 'Manitoba',
    SK: 'Saskatchewan', AB: 'Alberta', BC: 'British Columbia' };
  var cache = new Map();
  function current(state) { return active === state && state.grid.isConnected; }
  function baseKey() {
    var url = new URL(location.href);
    url.searchParams.delete('page'); url.searchParams.delete('province');
    return url.href;
  }
  function pageNumber(url) { return Number(new URL(url, location.href).searchParams.get('page') || 1); }
  // Dawn search uses #product-grid on a wrapper containing the list, whereas
  // collection pages put that ID on the list itself. Only replace list items.
  function productList(root) {
    var grid = root.querySelector('#product-grid');
    if (!grid) return null;
    return grid.matches('ul, ol') ? grid : grid.querySelector('ul.product-grid, ol.product-grid');
  }
  function extract(doc, url) {
    var container = doc.getElementById('ProductGridContainer');
    var grid = container && productList(container);
    if (!container || !grid) throw new Error('The next results page could not be read.');
    var next = null, number = pageNumber(url);
    container.querySelectorAll('.pagination-wrapper a[href], .pagination a[href]').forEach(function (link) {
      var candidate = new URL(link.getAttribute('href'), url);
      if (candidate.origin !== location.origin || candidate.pathname !== location.pathname) return;
      var n = pageNumber(candidate.href);
      if (n > number && (!next || n < pageNumber(next))) next = candidate.href;
    });
    var items = Array.from(grid.children).filter(function (node) {
      return node.matches('.grid__item') && node.querySelector('[data-tnt-destination-variant]');
    }).map(function (node) { return node.cloneNode(true); });
    return { items: items, next: next };
  }
  function identity(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (link) return new URL(link.href, location.href).pathname.split('/products/').pop();
    var marker = item.querySelector('[data-tnt-destination-variant]');
    return marker && marker.dataset.tntDestinationVariant;
  }
  function render(state) {
    if (!current(state)) return;
    var area = names[state.province], shown = state.shown;
    state.count.textContent = state.error ? 'More results could not be loaded. Please retry.'
      : state.busy ? 'Finding available products for ' + area + '…'
      : !state.next && !state.buffer.length
        ? (shown ? shown + ' product' + (shown === 1 ? '' : 's') + ' available in ' + area : 'No products available in ' + area + ' for these filters.')
        : 'Showing ' + shown + ' products for ' + area;
    state.button.textContent = state.error ? 'Retry loading products' : state.busy ? 'Finding products…' : 'Load more';
    state.button.disabled = state.busy;
    state.button.hidden = !state.busy && !state.error && !state.next && !state.buffer.length;
    state.grid.setAttribute('aria-busy', String(state.busy));
  }
  async function readPage(state, url) {
    var key = baseKey() + '|page=' + pageNumber(url);
    // Together with the stock call, keep ordinary browsing below the shared
    // stock/cart endpoint's 30 requests/minute limit. One HTML request at a time.
    await new Promise(function (resolve) { setTimeout(resolve, Math.max(0, 2500 - (Date.now() - lastRequest))); });
    if (!current(state)) return null;
    lastRequest = Date.now();
    if (cache.has(key)) return cache.get(key);
    var controller = new AbortController();
    state.abort = controller;
    var deadline = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Results request failed: ' + response.status);
      var html = await response.text();
      var result = extract(new DOMParser().parseFromString(html, 'text/html'), url);
      if (cache.size >= 60) cache.delete(cache.keys().next().value);
      cache.set(key, result);
      return result;
    } finally { clearTimeout(deadline); }
  }
  async function fill(state) {
    if (!current(state) || state.busy) return;
    state.busy = true; state.error = false;
    var target = state.shown + PAGE_SIZE;
    render(state);
    try {
      while (current(state) && state.shown < target) {
        while (state.buffer.length && state.shown < target) {
          var item = state.buffer.shift();
          item.classList.remove('scroll-trigger--offscreen');
          item.querySelectorAll('.scroll-trigger--offscreen').forEach(function (node) {
            node.classList.remove('scroll-trigger--offscreen');
          });
          state.grid.appendChild(item); state.shown++;
        }
        if (state.shown >= target || !state.next) break;
        var url = state.next;
        if (state.visited.has(url)) throw new Error('Results pagination repeated a page.');
        var page = await readPage(state, url);
        if (!current(state) || !page) return;
        var items = page.items.map(function (node) { return node.cloneNode(true); });
        // Failed stock checks must actually be retried, not cached as complete.
        items.forEach(function (item) {
          item.querySelectorAll('[data-tnt-destination-variant]').forEach(function (marker) {
            delete marker.dataset.tntCheckedProvince;
            delete marker.dataset.tntCheckedGeneration;
          });
        });
        await window.TntProvinceStock.prepareCards(items);
        if (!current(state)) return;
        if (items.some(function (item) {
          var card = item.querySelector('.card-wrapper');
          return !card || !['ready', 'unavailable'].includes(card.dataset.tntDestinationState);
        })) throw new Error('Some products could not be checked.');
        items.forEach(function (item) {
          var id = identity(item), card = item.querySelector('.card-wrapper');
          // Cart exemptions (levies, installation, staff studding, warranty)
          // are not standalone tire/wheel shopping results.
          if (card.dataset.tntDestinationState === 'ready' &&
              card.dataset.tntDestinationExempt !== 'true' && !state.seen.has(id)) {
            state.seen.add(id); state.buffer.push(item);
          }
        });
        // Advance only after the entire page was checked successfully.
        state.visited.add(url); state.next = page.next;
      }
    } catch (_) {
      if (current(state)) state.error = true;
    } finally {
      if (current(state)) { state.busy = false; render(state); }
    }
  }
  function start() {
    var core = window.TntProvinceStock;
    var container = document.getElementById('ProductGridContainer');
    var grid = container && productList(container);
    if (!core || !grid || !/\/(?:search|collections\/)/.test(location.pathname) ||
        window.__tntQuickResultsOwnGrid || !core.selectedProvince()) return;
    var key = baseKey(), province = core.selectedProvince();
    if (!resetRequested && active && active.grid === grid && active.key === key && active.province === province) return;
    resetRequested = false;
    if (active && active.abort) active.abort.abort();
    var initial = new URL(location.href);
    // Start at the beginning when entering via an old numbered-page link.
    initial.searchParams.delete('page');
    var firstKey = key + '|page=1';
    if (!cache.has(firstKey) && pageNumber(location.href) === 1) {
      cache.set(firstKey, extract(document, location.href));
    }
    if (active && active.controls.isConnected) active.controls.remove();
    var count = document.getElementById('tnt-destination-count');
    if (!count) {
      count = document.createElement('p'); count.id = 'tnt-destination-count';
      count.setAttribute('role', 'status'); grid.before(count);
    }
    var controls = document.createElement('div');
    controls.className = 'tnt-destination-pagination';
    var button = document.createElement('button');
    button.type = 'button'; button.className = 'button button--secondary';
    controls.appendChild(button); grid.after(controls);
    var state = { key: key, province: province, grid: grid, count: count,
      controls: controls, button: button, shown: 0, buffer: [], next: initial.href,
      seen: new Set(), visited: new Set(), busy: false, error: false };
    active = state;
    // Native page numbers describe unfiltered pages, so they are replaced by
    // one eligible-results cursor. Their links are retained in cached sources.
    container.querySelectorAll('.pagination-wrapper').forEach(function (node) { node.hidden = true; });
    grid.replaceChildren();
    button.addEventListener('click', function () { fill(state); });
    fill(state);
  }
  window.TntDestinationResults = { owns: function (grid) {
    return !!active && !!grid && (active.grid === grid || grid.contains(active.grid));
  } };
  function schedule() { clearTimeout(bootTimer); bootTimer = setTimeout(start, 0); }
  document.addEventListener('tnt:provinceChanged', function () {
    resetRequested = true;
    schedule();
  });
  new MutationObserver(function () {
    if (!document) return;
    var grid = productList(document);
    if (!active || active.grid !== grid || active.key !== baseKey()) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
